import { render, staticRenderFns } from "./ClaioImageThumbnail.vue?vue&type=template&id=7aa8ffee&scoped=true&"
import script from "./ClaioImageThumbnail.vue?vue&type=script&lang=ts&"
export * from "./ClaioImageThumbnail.vue?vue&type=script&lang=ts&"
import style0 from "./ClaioImageThumbnail.vue?vue&type=style&index=0&id=7aa8ffee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa8ffee",
  null
  
)

export default component.exports